var map = {
	"./DSCF7872.jpg": 8301,
	"./DSCF7884.jpg": 155,
	"./DSCF7891.jpg": 3102,
	"./DSCF7908.jpg": 682,
	"./DSCF7923.jpg": 8787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6294;